import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Slider from '@mui/material/Slider';
import {rgba} from 'polished';
import utils from 'helpers/utils';

const StyledSlider = styled(Slider)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--slider-focus-shadow-medium': `0 0 0 ${props.theme.layout(4)} ${rgba(props.theme.property(`palette.${props.color}`)?.main, 0.16)}`,
      '--slider-active-shadow-medium': `0 0 0 ${props.theme.layout(6)} ${rgba(props.theme.property(`palette.${props.color}`)?.main, 0.16)}`,
      '--slider-focus-shadow-small': `0 0 0 ${props.theme.layout(3)} ${rgba(props.theme.property(`palette.${props.color}`)?.main, 0.16)}`,
      '--slider-active-shadow-small': `0 0 0 ${props.theme.layout(4)} ${rgba(props.theme.property(`palette.${props.color}`)?.main, 0.16)}`
    };

    return utils.styleProps(attr, vars);
  })`
  .MuiSlider-thumb {
    border: 2px solid ${props => props.theme.property('palette.background.paper')};
    
    &.MuiSlider-thumbSizeMedium {
      ${props => props.theme.state2Selector('MuiSlider-thumb', null, ['hover', 'focus', 'focusVisible'])} {
        box-shadow: ${props => props.$css.$var('--slider-focus-shadow-medium')};
      }
      &.Mui-active {
        box-shadow: ${props => props.$css.$var('--slider-active-shadow-medium', false)} !important;
      }
    }

    &.MuiSlider-thumbSizeSmall {
      ${props => props.theme.state2Selector('MuiSlider-thumb', null, ['hover', 'focus', 'focusVisible'])} {
        box-shadow: ${props => props.$css.$var('--slider-focus-shadow-small')};
      }
      &.Mui-active {
        box-shadow: ${props => props.$css.$var('--slider-active-shadow-small', false)} !important;
      }
    }
  }

  .MuiSlider-markLabel {
    font-size: ${props => props.theme.fontSize(13)};
    top: ${props => props.theme.layout('3.5sp')};
  }
  
  &.Slider-hideThumbs {
    .MuiSlider-thumb {
      display: none;
    }
  }
  
  &.Slider-hideMarkLabels {
    margin-bottom: 0;
    .MuiSlider-markLabel {
      display: none;
    }
  }
  
  &.Slider-disabled {
    .MuiSlider-markLabel {
      color: ${props => props.theme.property('palette.action.disabled')} !important;
    }
  }
  
  ${ComponentStyles}
`;

StyledSlider.propTypes = {
  theme: PropTypes.object
};

export default StyledSlider;
